<template>
  <div class="nosto-active-values">
    <div
      v-if="!isMobile"
      class="nosto-active-values__wrapper--desktop"
    >
      <div
        v-for="(filters, groupName) of groupedChoices"
        :key="groupName"
        class="nosto-active-values__group"
      >
        <div class="nosto-active-values__group-title">
          <span class="text-body-2xs">{{ groupName }}:</span>
        </div>

        <div class="nosto-active-values__tags-container">
          <div
            v-for="(filter, index) of filters"
            :key="`${filter.original}-${index}`"
            class="nosto-active-values__tags--desktop"
          >
            <nosto-active-value-tag
              :choice="filter.original"
              :display-value="filter.displayValue"
              :sort-by-options="sortByOptions"
              :count="filter.count"
              tabindex="0"
              @click.prevent="choicesUpdated(filter.original)"
            />
          </div>
        </div>
      </div>

      <template v-if="Object.keys(groupedChoices).length === 0">
        <div
          v-for="(choice, index) of activeChoices"
          :key="`${choice}-${index}`"
          class="nosto-active-values__tags--desktop"
        >
          <nosto-active-value-tag
            v-if="!choice.includes('page')"
            :choice="choice"
            :sort-by-options="sortByOptions"
            tabindex="0"
            @click.prevent="choicesUpdated(choice)"
          />
        </div>
      </template>
    </div>

    <div
      v-else
      class="nosto-active-values__wrapper"
    >
      <div
        v-for="(choice, index) of activeChoices"
        :key="`${choice}-${index}`"
        class="nosto-active-values__tags"
      >
        <nosto-active-value-tag
          v-if="!choice.includes('page')"
          :choice="choice"
          :sort-by-options="sortByOptions"
          tabindex="0"
          @click.prevent="choicesUpdated(choice)"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: nosto active values (nosto-active-values)
 * -----------------------------------------------------------------------------
 * Selected filter values and 'clear all' button for nosto filters.
 *
 * @param {Array} activeChoices - Current active choices (excluding pagination).
 * @param {Object} sortByOptions - Options for sorting.
 *
 */
import NostoActiveValueTag from '~async/nosto-grid/nosto-active-value-tag'
import { mapState } from 'vuex'

export default {
  name: 'NostoActiveValues',

  components: {
    NostoActiveValueTag,
  },

  props: {
    activeChoices: {
      type: Array,
      default: () => [],
    },
    groupedChoices: {
      type: Object,
      default: () => ({}),
    },
    sortByOptions: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: {
    'choices-updated': (payload) => typeof payload === 'object',
    'clear-choices': () => true,
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {

    /**
     * Receive user input from tags and pass up to filter component.
     * @param {String} choice - Clicked choice.
     */
    choicesUpdated(choice) {
      const data = {
        requestParam: `&${decodeURIComponent(choice)}`,
        action: 'remove',
      }

      this.$emit('choices-updated', data)
    },
  },
}
</script>

<style lang="scss">
@import './nosto-active-values';
@import '~async/nosto-grid/nosto-active-value-tag';
</style>
